import { ApplicationStatus } from 'api/LoanOriginationSystem/LoanOriginationSystemApplicationStatusesApi';
import { ApplicationStatusRulesValidationResult } from 'api/LoanOriginationSystem/ApplicationStatusesRulesValidationApi';
import ChangeApplicationStatusError from './ChangeApplicationStatusError';

export default class ApplicationStatusRulesValidationError extends ChangeApplicationStatusError {
  constructor(
    applicationId: string,
    applicationName: string,
    applicationDisplayId: string,
    initialStatus: ApplicationStatus,
    index: number | undefined,
    readonly statusRulesValidationResult: ApplicationStatusRulesValidationResult,
  ) {
    super('', applicationId, applicationDisplayId, applicationName, initialStatus, index);
  }
}
